



































import { defineComponent, computed } from '@nuxtjs/composition-api'
import { jsonToHtml } from '@contentstack/json-rte-serializer'
import { storeToRefs } from 'pinia'
import { PdpPage } from '@/modules/contentstack/types'
import { useProductStore } from '~/store/product'

export default defineComponent({
  props: {
    productIncludesData: {
      type: Object,
      required: false,
      default: undefined,
    },
    customProductIncludes: {
      type: Object as () => PdpPage,
      required: false,
      default: undefined,
    },
  },
  setup(props) {
    const { currentProduct } = storeToRefs(useProductStore())

    const footnotes = computed(() => currentProduct.value?.data?.attributes?.kits?.footnotes?.footnote || [])

    const serializedCustomProductIncludes = computed(() =>
      props.customProductIncludes?.components?.at(0)?.pdp_product_inquiry?.content?.json
        ? jsonToHtml(props.customProductIncludes?.components?.at(0)?.pdp_product_inquiry?.content?.json, {
            allowNonStandardTypes: true,
          })
        : undefined
    )
    return { serializedCustomProductIncludes, footnotes }
  },
})
